import { api } from './api'
import { ClinicHours, ClinicHoursFormData } from '../types/clinicHours'

export const clinicHoursService = {
  /**
   * Get current clinic hours configuration
   */
  getCurrent: async (): Promise<ClinicHours> => {
    const response = await api.get<ClinicHours>('/settings/clinic-hours')
    return response.data
  },

  /**
   * Update clinic hours configuration
   */
  update: async (data: ClinicHoursFormData): Promise<ClinicHours> => {
    const response = await api.put<ClinicHours>('/settings/clinic-hours', data)
    return response.data
  },

  /**
   * Get available time slots for a specific date based on clinic hours
   */
  getAvailableSlotsForDate: async (date: string): Promise<string[]> => {
    const response = await api.get<string[]>('/settings/clinic-hours/available-slots', {
      params: { date },
    })
    return response.data
  },
}



































